import React from 'react';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Material UI
import MuiRadio from '@material-ui/core/Radio';
import MuiRadioGroup from '@material-ui/core/RadioGroup';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
// Internal
import { getMuiColor } from './internal/Tools';

const Radio = ({
  color, icon, checkedIcon, ...otherProps
}) => {
  // Component props
  let radioProps = { color };
  if (icon) {
    radioProps = { ...radioProps, icon };
  }
  if (checkedIcon) {
    radioProps = { ...radioProps, checkedIcon };
  }

  return (
    <MuiRadio {...radioProps} {...otherProps} />
  );
};

Radio.propTypes = {
  color: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.object]),
  checkedIcon: PropTypes.oneOfType([PropTypes.element, PropTypes.object]),
};

Radio.defaultProps = {
  icon: null,
  checkedIcon: null,
};

const RadioGroup = ({
  value: currentValue, items, primary, secondary, row, disabled, onChange,
}) => {
  // MUI color
  const color = getMuiColor(primary, secondary);

  // Change handler
  const handleChange = onChange ? (e) => onChange(e.target.value) : null;

  // Components props
  const radioGroupProps = { value: currentValue, row, onChange: handleChange };

  return (
    <MuiRadioGroup {...radioGroupProps}>
      {_map(items, ({
        key, value, label, icon, checkedIcon,
      }) => (
        <MuiFormControlLabel
          key={key}
          value={value}
          label={label}
          control={(
            <Radio
              color={color}
              icon={icon}
              checkedIcon={checkedIcon}
              disabled={disabled}
            />
          )}
        />
      ))}
    </MuiRadioGroup>
  );
};

RadioGroup.propTypes = {
  value: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      icon: PropTypes.oneOfType([PropTypes.element, PropTypes.object]),
      checkedIcon: PropTypes.oneOfType([PropTypes.element, PropTypes.object]),
    }),
  ).isRequired,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  row: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

RadioGroup.defaultProps = {
  value: null,
  primary: true,
  secondary: false,
  row: false,
  disabled: false,
  onChange: null,
};

export default React.memo(RadioGroup);



// WEBPACK FOOTER //
// ./components/core/RadioGroup.js